const Items = [
  // {
  //   id: 1,
  //   mainImage: "https://res.cloudinary.com/du541igfh/image/upload/v1682699543/Blog%20Portfolio%20Gilbert/Project/msnproduction/img-1_rmh7lp.png",
  //   img: [
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1682699543/Blog%20Portfolio%20Gilbert/Project/msnproduction/img-1_rmh7lp.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1682699548/Blog%20Portfolio%20Gilbert/Project/msnproduction/img-2_p3chy5.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1682699706/Blog%20Portfolio%20Gilbert/Project/msnproduction/img-3_uhtwa6.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1682699802/Blog%20Portfolio%20Gilbert/Project/msnproduction/img-4_p404nm.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1682700118/Blog%20Portfolio%20Gilbert/Project/msnproduction/img-5_mksj57.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1682700238/Blog%20Portfolio%20Gilbert/Project/msnproduction/img-6_jfndeo.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1682700374/Blog%20Portfolio%20Gilbert/Project/msnproduction/img-7_uhh453.png",
  //   ],
  //   features: [
  //     "Home",
  //     "About",
  //     "Package",
  //     "Contact",
  //     "Blog",
  //     "A user can order through the Admin for Website services, Mobile Applications, Branding & Creative Content, as well as Internet Marketing & Advertising.",
  //     "Responsive Design",
  //     "404 Page and many more.",
  //   ],
  //   technologies: [
  //     "React",
  //     "TailwindCSS",
  //     "React Leaflet",
  //     "React Hooks",
  //     "React icons",
  //     "Email JS",
  //     "Framer Motion",
  //   ],
  //   title: "Msn Production",
  //   description:
  //     "MULIA SEJATI NUSANTARA Established on June 24, 2019, a limited liability company engaged in supplier & contractor services. Then on January 22 2022 PT. MULIA SEJATI NUSANTARA Opening a new business branch in the Technology Sector which includes Website Creation, Mobile Applications, Branding, Creative Content, Digital Marketing & Advertising. This branch is called Mulia Sejati Nusantara Production or in short MSN PRODUCTION.",
  //   category: "business",
  //   liveLink: "https://msnproduction.com/",
  //   codeLink: "https://github.com/berthutapea/msnproduction.com",
  // },
  // {
  //   id: 2,
  //   mainImage: "https://res.cloudinary.com/du541igfh/image/upload/v1682701479/Blog%20Portfolio%20Gilbert/Project/mern-blog/img-4_kmaye9.png",
  //   img: [
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1682701456/Blog%20Portfolio%20Gilbert/Project/mern-blog/img-1_jppjdj.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1682701463/Blog%20Portfolio%20Gilbert/Project/mern-blog/img-2_ptr4lg.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1682701467/Blog%20Portfolio%20Gilbert/Project/mern-blog/img-3_gjle1m.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1682701479/Blog%20Portfolio%20Gilbert/Project/mern-blog/img-4_kmaye9.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1682701489/Blog%20Portfolio%20Gilbert/Project/mern-blog/img-5_nuhniv.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1682701492/Blog%20Portfolio%20Gilbert/Project/mern-blog/img-6_rkvmhd.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1682701496/Blog%20Portfolio%20Gilbert/Project/mern-blog/img-7_xjm4pm.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1682701499/Blog%20Portfolio%20Gilbert/Project/mern-blog/img-8_dj0qoq.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1682701502/Blog%20Portfolio%20Gilbert/Project/mern-blog/img-9_d1h5a0.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1682701505/Blog%20Portfolio%20Gilbert/Project/mern-blog/img-10_kbbkd4.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1682701506/Blog%20Portfolio%20Gilbert/Project/mern-blog/img-11_mmspfs.png",
  //   ],
  //   features: [
  //     "User registration and login",
  //     "Authentication using JWT Tokens",
  //     "Story searching and pagination",
  //     "CRUD operations (Story create, read, update and delete)",
  //     "Upload user ımages and story ımages to the server",
  //     "Liking stories and adding stories to the Reading list",
  //     "Commenting on the story",
  //     "Skeleton loading effect",
  //     "Responsive Design",
  //     "404 Page and many more.",
  //   ],
  //   technologies: [
  //     "React",
  //     "React Hooks",
  //     "React Icons",
  //     "Axios",
  //     "CSS",
  //     "UUID",
  //     "NodeJS",
  //     "ExpressJS",
  //     "MongoDB",
  //     "Mongoose",
  //     "Express Asynsc Handler",
  //     "Json Web Token",
  //     "Bcryptjs",
  //     "Nodemailer",
  //     "Dontenv",
  //     "Multer",
  //     "Slugify",
  //     "Cors",
  //   ],
  //   title: "Mern Blog",
  //   description:
  //     "Fullstack open source blogging application made with MongoDB, Express, React & Nodejs (MERN)",
  //   category: "personal",
  //   liveLink: "https://berthutapea.vercel.app/mern-blog",
  //   codeLink: "https://github.com/berthutapea/mern-blog-v2",
  // },
  {
    id: 3,
    mainImage:
      "https://ucarecdn.com/b61f1d1d-1d52-4fd0-baf4-61bfadca9d4e/CuteElegantBlackVideoCinematographyBusinessLogo.png",
    img: [
      "https://res.cloudinary.com/du541igfh/image/upload/v1684312778/Blog%20Portfolio%20Gilbert/Project/mern-movie/img-1_lcun2a.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1684312777/Blog%20Portfolio%20Gilbert/Project/mern-movie/img-2_ar1fex.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1684312780/Blog%20Portfolio%20Gilbert/Project/mern-movie/img-3_qpebgb.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1684312777/Blog%20Portfolio%20Gilbert/Project/mern-movie/img-4_yadwtg.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1684312780/Blog%20Portfolio%20Gilbert/Project/mern-movie/img-5_xvx0vj.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1684312773/Blog%20Portfolio%20Gilbert/Project/mern-movie/img-6_aaq4yf.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1684312772/Blog%20Portfolio%20Gilbert/Project/mern-movie/img-7_twij3j.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1684312773/Blog%20Portfolio%20Gilbert/Project/mern-movie/img-8_njclct.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1684312774/Blog%20Portfolio%20Gilbert/Project/mern-movie/img-9_zg1jfe.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1684312772/Blog%20Portfolio%20Gilbert/Project/mern-movie/img-10_yag7bj.png",
    ],
    features: [
      "User registration and login",
      "Authentication using JWT Tokens",
      "Add Favorites",
      "Delete Favorites",
      "Leave a Reviews",
      "Delete Reviews",
      "Password Update",
      "Search Live",
      "Watch the trailer on Youtube",
      "404 Page and many more",
      "Skeleton loading effect",
      "DarkMode",
      "DarkMode",
      "Responsive Design",
    ],
    technologies: [
      "React",
      "React Hooks",
      "React Router Dom",
      "Axios",
      "Material UI",
      "CK Editor",
      "Formik",
      "React Redux",
      "React Toastify",
      "Swiper",
      "NodeJS",
      "ExpressJS",
      "Mongoose",
      "Json Web Token",
      "Cookie Parser",
      "Cors",
      "Dontenv",
      "Express Validator",
      "Nodemon",
      "MongoDB",
      "TMDB API",
    ],
    title: "Fawzi Movies",
    description:
      "Fullstack open source movie application made with MongoDB, Express, React & Nodejs (MERN)",
    category: "personal",
    liveLink: "https://bertflix.vercel.app/",
    // codeLink: "https://github.com/berthutapea/mern-movie",
  },
  // {
  //   id: 4,
  //   mainImage: "https://res.cloudinary.com/du541igfh/image/upload/v1682772430/Blog%20Portfolio%20Gilbert/Project/mern-penggajian-karyawan/img-2_vsab0u.png",
  //   img: [
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1682772430/Blog%20Portfolio%20Gilbert/Project/mern-penggajian-karyawan/img-1_gywmlj.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1682772430/Blog%20Portfolio%20Gilbert/Project/mern-penggajian-karyawan/img-2_vsab0u.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1682772430/Blog%20Portfolio%20Gilbert/Project/mern-penggajian-karyawan/img-3_ktppfh.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1682772430/Blog%20Portfolio%20Gilbert/Project/mern-penggajian-karyawan/img-4_g9pcqp.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1682772430/Blog%20Portfolio%20Gilbert/Project/mern-penggajian-karyawan/img-5_cugdqq.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1682772430/Blog%20Portfolio%20Gilbert/Project/mern-penggajian-karyawan/img-6_d550ha.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1682772431/Blog%20Portfolio%20Gilbert/Project/mern-penggajian-karyawan/img-7_u2td2u.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1682772431/Blog%20Portfolio%20Gilbert/Project/mern-penggajian-karyawan/img-8_tt0tqg.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1682772431/Blog%20Portfolio%20Gilbert/Project/mern-penggajian-karyawan/img-9_thcxyv.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1682772431/Blog%20Portfolio%20Gilbert/Project/mern-penggajian-karyawan/img-10_wwmqty.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1682772431/Blog%20Portfolio%20Gilbert/Project/mern-penggajian-karyawan/img-11_issyrd.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1682772431/Blog%20Portfolio%20Gilbert/Project/mern-penggajian-karyawan/img-12_visvli.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1682772431/Blog%20Portfolio%20Gilbert/Project/mern-penggajian-karyawan/img-13_dqy6wg.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1682772431/Blog%20Portfolio%20Gilbert/Project/mern-penggajian-karyawan/img-14_kvaem7.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1682772432/Blog%20Portfolio%20Gilbert/Project/mern-penggajian-karyawan/img-15_pzdxsu.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1682772431/Blog%20Portfolio%20Gilbert/Project/mern-penggajian-karyawan/img-16_ven89o.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1682772432/Blog%20Portfolio%20Gilbert/Project/mern-penggajian-karyawan/img-17_wjwedp.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1682772432/Blog%20Portfolio%20Gilbert/Project/mern-penggajian-karyawan/img-18_zpsewd.png",
  //   ],
  //   features: [
  //     "Login Admin",
  //     "Add employee",
  //     "Edit employee",
  //     "Remove employee",
  //     "Add position",
  //     "Edit position",
  //     "Remove position",
  //     "Display data, input attendance, edit attendance and delete employee absences",
  //     "Employee Salary Deduction Setting",
  //     "Display data, input salary data, edit salary data and delete employee salary data",
  //     "Print payroll reports, absences, and payslips",
  //     "Change admin and employee passwords",
  //     "Login Employees/Staff",
  //     "Print employees/staff salary reports from personal accounts",
  //     "404 Page and many more",
  //     "Responsive Design",
  //   ],
  //   technologies: [
  //     "React",
  //     "React Hooks",
  //     "React Icons",
  //     "React Vite",
  //     "Redux",
  //     "Redux Toolkit",
  //     "Tailwind CSS",
  //     "Apexcharts",
  //     "Localforage",
  //     "Match Sorter",
  //     "Axios",
  //     "Node JS",
  //     "Express JS",
  //     "MySQL",
  //     "Cors",
  //     "JWT",
  //     "Bycrypt",
  //     "Cookie Parser",
  //     "Dotenv",
  //     "MySQL 12",
  //     "Nodemon",
  //     "Sequelize",
  //   ],
  //   title: "Employee Salary Management",
  //   description:
  //     "Warehouse website with employee/employee management, add employee and job title options. Employee attendance data setting salary deductions and salary data. Print salary reports, attendance and salary data and many other features.",
  //   category: "business",
  //   liveLink: "https://berthutapea.vercel.app/employee-salary-management",
  //   codeLink: "https://github.com/berthutapea/mern-employee-salary-management",
  // },
  // {
  //   id: 5,
  //   mainImage: "https://res.cloudinary.com/du541igfh/image/upload/v1683869747/Blog%20Portfolio%20Gilbert/Project/mern-student-management-system/img-1_yhedpu.png",
  //   img: [
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1683869747/Blog%20Portfolio%20Gilbert/Project/mern-student-management-system/img-1_yhedpu.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1683869747/Blog%20Portfolio%20Gilbert/Project/mern-student-management-system/img-2_uktrxk.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1683869747/Blog%20Portfolio%20Gilbert/Project/mern-student-management-system/img-3_s1js9i.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1683869747/Blog%20Portfolio%20Gilbert/Project/mern-student-management-system/img-4_sb9ga6.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1683869748/Blog%20Portfolio%20Gilbert/Project/mern-student-management-system/img-5_wrxlr7.png",
  //   ],
  //   features: [
  //     "Add Student",
  //     "Edit Student",
  //     "Remove Student",
  //     "No Student Page",
  //     "Responsive Design",
  //     "404 Page and many more",
  //   ],
  //   technologies: [
  //     "React",
  //     "React Hooks",
  //     "React Router Dom",
  //     "Axios",
  //     "Bootstrap",
  //     "React Icons",
  //     "Sweet Alert2",
  //     "Node JS",
  //     "Express JS",
  //     "Cors",
  //     "Mongoose",
  //     "Dotenv",
  //     "Nodemon",
  //     "MongoDB",
  //   ],
  //   title: "Student Management System",
  //   description:
  //     "Fullstack open source student management system application made with MongoDB, Express, React & Nodejs (MERN)",
  //   category: "business",
  //   liveLink: "https://sttiss.vercel.app/",
  //   codeLink: "https://github.com/berthutapea/mern-student-management-system",
  // },
  {
    id: 6,
    mainImage:
      "https://ucarecdn.com/64daaf83-efe5-49d0-aee2-2401f18543ab/mario.webp",
    img: [
      "https://res.cloudinary.com/du541igfh/image/upload/v1682964283/Blog%20Portfolio%20Gilbert/Project/mario-jump-game/img-1_gpiiro.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682964283/Blog%20Portfolio%20Gilbert/Project/mario-jump-game/img-2_iwduig.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682964283/Blog%20Portfolio%20Gilbert/Project/mario-jump-game/img-3_sk2hyn.png",
    ],
    features: [
      "Mobile Responsive",
      "Beautiful Animations",
      "Rapid Controls",
      "High Score",
      "Mario Background Music",
      "Jump & Game Over Sound Effect",
    ],
    technologies: [
      "React",
      "CSS",
      "React Hooks",
      "React Router",
      "React Redux",
    ],
    title: "Mario Jump",
    description:
      "Mario Jump is an endless running game inspired by the famous Google Chrome's T-Rex Dinosaur Game 🦖. The game is built entirely with ReactJS ⚛ and Redux Toolkit 🔧.",
    category: "game",
    liveLink: "https://mariojumpp.vercel.app/",
    // codeLink: "https://github.com/berthutapea/mario-jump-game",
  },
  {
    id: 7,
    mainImage:
      "https://ucarecdn.com/ed07f9fb-0129-4dcd-9caf-87943a79d4a1/YellowBlackBrushStreetwearBrandLogo.png",
    img: [
      "https://res.cloudinary.com/du541igfh/image/upload/v1682944091/Blog%20Portfolio%20Gilbert/Project/bert-quiz/img-1_gqero4.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682944091/Blog%20Portfolio%20Gilbert/Project/bert-quiz/img-2_ukjdh2.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682944695/Blog%20Portfolio%20Gilbert/Project/bert-quiz/img-3_t6uxoj.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682944091/Blog%20Portfolio%20Gilbert/Project/bert-quiz/img-4_btevir.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682944091/Blog%20Portfolio%20Gilbert/Project/bert-quiz/img-5_oakjx2.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682944092/Blog%20Portfolio%20Gilbert/Project/bert-quiz/img-6_pqefy9.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1682944091/Blog%20Portfolio%20Gilbert/Project/bert-quiz/img-7_wfrvb7.png",
    ],
    features: [
      "User registration and login",
      "Select the type of question and the difficulty level of the question",
      "Juis time is running and after the time is up it stops automatically",
      "The final results of the answers answered will be shown",
      "Incorrect and correct answer results will be displayed",
      "Responsive Design",
    ],
    technologies: [
      "React",
      "React Vite",
      "Tailwind CSS",
      "Firebase Authentication",
      "Framer Motion",
      "React Firebase Hooks",
      "React Icons",
    ],
    title: "Fawzi Quiz",
    description: "Fullstack open source quiz application",
    category: "personal",
    liveLink: "https://bertquiz.vercel.app/",
    // codeLink: "https://github.com/berthutapea/react-quiz",
  },
  // {
  //   id: 8,
  //   mainImage: "https://res.cloudinary.com/du541igfh/image/upload/v1683033408/Blog%20Portfolio%20Gilbert/Project/shopify/img-1_q5d6pn.png",
  //   img: [
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1683033408/Blog%20Portfolio%20Gilbert/Project/shopify/img-1_q5d6pn.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1683033411/Blog%20Portfolio%20Gilbert/Project/shopify/img-2_nko9ic.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1683033413/Blog%20Portfolio%20Gilbert/Project/shopify/img-3_rnhbr1.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1683033408/Blog%20Portfolio%20Gilbert/Project/shopify/img-4_ks8lck.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1683033409/Blog%20Portfolio%20Gilbert/Project/shopify/img-5_eotroj.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1683033408/Blog%20Portfolio%20Gilbert/Project/shopify/img-6_fgpzef.png",
  //   ],
  //   features: [
  //     "Mobile Responsive",
  //     "Beautiful Animations",
  //     "Product",
  //     "Pricing",
  //     "Testimonial",
  //     "Contact",
  //   ],
  //   technologies: [
  //     "React",
  //     "React Vite",
  //     "Tailwind CSS",
  //     "Framer Motion",
  //     "React Icons",
  //     "React Hooks",
  //   ],
  //   title: "Shopify",
  //   description:
  //     "Open source landing page shopify application",
  //   category: "personal",
  //   liveLink: "https://shopifyy.vercel.app/",
  //   codeLink: "https://github.com/berthutapea/react-shopify-landing",
  // },
  {
    id: 9,
    mainImage:
      "https://ucarecdn.com/69e0dcfb-eef9-421f-98a5-4967a3b2b791/PlayForge.ico",
    img: [
      "https://ucarecdn.com/08de8449-938d-4beb-91ec-90a7e2719d81/Screenshot20250302163845.png",
      "https://ucarecdn.com/a3bf282a-d023-4e48-9c5c-d75b721145b2/Screenshot20250302223151.png",
      "https://ucarecdn.com/81ff7f23-bcdb-4399-b7b6-adafcb0d4ff0/Screenshot20250302223738.png",
      "https://ucarecdn.com/386e011a-97fd-42ea-852d-ca0e7cf4e554/Screenshot20250302224127.png",
      "https://ucarecdn.com/139d5922-f7fa-4d4e-ac49-cce5abce9c5d/Screenshot20250302224207.png",
      "https://ucarecdn.com/0f45a68e-502f-4c97-93de-bbbe82012309/Screenshot20250302224053.png",
      "https://ucarecdn.com/fff1356a-a54a-464a-8af9-a2816b5e2c79/Screenshot20250302223250.png",
      "https://ucarecdn.com/cc278bff-c76a-4332-8884-dda1aeeac4c0/Screenshot20250302223840.png",
      "https://ucarecdn.com/6dd4526c-7269-48b4-921e-368cf4e8eb00/Screenshot20250302223706.png",
    ],
    features: [
      "Posts",
      "Searching",
      "Filter and Pagination",
      "Profile",
      "Comments",
      "Reaction",
      "Games",
    ],
    technologies: ["React", "TailwindCSS", "React Hooks", "React icons"],
    title: "Play Forge",
    description:
      "Play Forge is a react, tailwind based frontend for a gaming forum. Play forge has UIs for both Admin and users to create and manage posts, comments, games, search posts, view user information, like,dislike and view posts, edit profile",
    category: "game",
    liveLink: "https://play-forge.vercel.app",
    codeLink: "https://github.com/Fawzi-Barry/Play-forge-Frontend",
  },
  {
    id: 10,
    mainImage:
      "https://ucarecdn.com/142d527a-3c38-41e8-a415-c619a5122bfc/ModernYellowPixelGamepadStudioGameLogo.png",
    img: [
      "https://ucarecdn.com/87c36f93-72e4-40fb-a283-31c83a81c1a7/Screenshot20250305164342.png",
      "https://ucarecdn.com/c26f4155-c1b5-45f6-abaf-8e1c1bdef52b/Screenshot20250305164400.png",
    ],
    features: ["Searching", "Filter", "Games"],
    technologies: ["React", "React Hooks", "React icons"],
    title: "Pixel Picks",
    description:
      "PixelPicks is a gaming platform powered by the RAWG API that allows users to explore a vast collection of video games. With PixelPicks, users can easily search for games, view their release dates, and check ratings to make informed decisions about what to play next. Whether you're looking for the latest releases or seeking out highly-rated classics, PixelPicks offers a seamless and user-friendly experience for all gaming enthusiasts.",
    category: "game",
    liveLink: "https://pixelpicks.vercel.app",
    codeLink: "https://github.com/Fawzi-Barry/pixel-picks",
  },
  {
    id: 11,
    mainImage:
      "https://ucarecdn.com/f76b7372-2836-4eb9-8419-a9c799019eae/BlackandWhiteRegularSportsLogo.png",
    img: [
      "https://ucarecdn.com/ea160d4d-0341-4e46-bc6c-65cf67662ae2/Screenshot20250305194057.png",
      "https://ucarecdn.com/71505292-e155-43f3-920a-8a2ec663b8f2/Screenshot20250305194003.png",
    ],
    features: [
      "Start/Stop Timer",
      "Reset Timer",
      "Simple UI",
      "Responsive Design",
    ],
    technologies: ["React", "React Hooks", "React icons"],
    title: "Stop Watch",
    description:
      "This stopwatch app lets you track time with ease. Built using React, it provides a simple, responsive interface to start, stop, and reset the timer.",
    category: "personal",
    liveLink: "https://react7-sepia.vercel.app",
    codeLink: "https://github.com/Fawzi-Barry/Stop-Watch/tree/main",
  },
  {
    id: 12,
    mainImage:
      "https://ucarecdn.com/51f5b470-3b2c-4cbc-bc21-325b2c543b45/Screenshot20250305172830.png",
    img: [
      "https://ucarecdn.com/51f5b470-3b2c-4cbc-bc21-325b2c543b45/Screenshot20250305172830.png",
      "https://ucarecdn.com/3355ffea-5a09-4570-8494-4ff86fed4c59/Screenshot20250305172452.png",
      "https://ucarecdn.com/af92c8ec-c568-479f-9d95-56c00565773b/Screenshot20250305172437.png",
      "https://ucarecdn.com/00920c58-4efa-435d-a13e-0b725fb96aa4/Screenshot20250305172419.png",
      "https://ucarecdn.com/01a58502-5532-41e6-8c39-0c546a4dfa3e/Screenshot20250305172401.png",
    ],
    features: ["Location Search", "Current Weather", "Mobile-Friendly"],
    technologies: ["React", "React Hooks", "React icons"],
    title: "Weather App",
    description:
      "This weather app provides real-time weather updates for any location. Built with React, it pulls weather data from an API to show current conditions, forecasts, and more.",
    category: "business",
    liveLink: "https://weatherrcheck.vercel.app",
    codeLink: "https://github.com/Fawzi-Barry/Weather-App",
  },
  {
    id: 13,
    mainImage:
      "https://ucarecdn.com/c079089a-695c-4781-8797-f4e820059d1f/BlackandWhiteCircleBusinessLogo.png",
    img: [
      "https://ucarecdn.com/d4640c86-0174-4423-9911-ab3784c87493/Screenshot20250612145000.png",
      "https://ucarecdn.com/face5d78-cd33-46e1-a656-cf9e57067906/Screenshot20250612144738.png",
      "https://ucarecdn.com/a3c727fd-328c-4c6c-baa9-79074f4a4d59/Screenshot20250612144724.png",
    ],
    features: [
      "Task creation, editing, and deletion (CRUD operations)",
      "Task categorization: To Do, In Progress, Completed",
      "Priority levels (e.g., High, Medium, Low)",
      "Dashboard overview of task statistics",
      "Real-time chart visualization by priority (Chart.js)",
      "Task filtering by status and date (e.g., Today, This Week, This Month)",
      "Visual task counters for each status",
      "User-friendly, responsive interface",
    ],
    technologies: [
      "React.js",
      "JavaScript",
      "Express.js",
      "MongoDB",
      "Chart.js",
      "Vercel",
      "RESTful APIs",
    ],
    title: "TaskMe",
    description:
      "A full-stack web application that helps users manage daily tasks through a cloud-based dashboard. Users can add, update, and track tasks by status and priority, with real-time visual insights. The platform offers an intuitive interface, dynamic filtering, and performance-optimized deployment.",
    category: "business",
    liveLink: "https://to-do-list-frontend-brown.vercel.app",
    //codeLink: "https://to-do-list-frontend-brown.vercel.app",
  },
  {
    id: 14,
    mainImage:
      "https://ucarecdn.com/8d89b5fb-f68c-40fa-90c9-4169dac15c5a/photo_20260713_223413.jpg",
    img: [
      "https://ucarecdn.com/14965c8e-b021-46bd-9775-142192195f2a/Screenshot20260821135540.png",
      "https://ucarecdn.com/42b62ca0-bdb6-4ab8-bb7d-0a7648db251c/Screenshot20260821135652.png",
      "https://ucarecdn.com/bc3ed0a7-c2ea-41ac-9495-a4aa5cebc3fc/Screenshot20260821135706.png",
      "https://ucarecdn.com/7a9b0a96-113d-4877-a16e-089ea1cd72cd/Screenshot20260821135733.png",
      "https://ucarecdn.com/cf2ced8f-8e23-4cdf-bd24-9d926c2022c7/Screenshot20260821135601.png",
      "https://ucarecdn.com/ec6f526f-6829-45f2-a81f-a477fcc59084/Screenshot20260821135717.png",
      "https://ucarecdn.com/dffbcf7b-a90b-42f0-843f-d37072b9afc6/Screenshot20260821135612.png",
    ],
    features: [
      "React.js & Node.js Development",
      "REST API Integration",
      "Component-Based Architecture",
      "Dynamic Content Rendering",
      "Responsive CSS & Modern Styling",
      "API & Backend Integration",
      "Reusable React Components",
      "Form Handling & Validation",
      "Performance Optimization",
      "Responsive & Cross-Browser Compatibility",
    ],
    technologies: [
      "React.js",
      "JavaScript",
      "Express.js",
      "Chart.js",
      "Vercel",
      "RESTful APIs",
    ],
    title: "Tomorrow is Better",
    description:
      "Designed and developed the Tomorrow Is Better website using React.js and Node.js, featuring a modern responsive UI, intuitive navigation, smooth animations, mobile optimization, and a user-friendly experience.",
    category: "business",
    liveLink: "https://www.tomorrowisbetter.org",
    //codeLink: "#",
  },
];

export default Items;
